var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWaiting = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 368.71,
    viewBox: "0 0 500 368.71",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Process-rafiki_1_",
    "data-name": "Process-rafiki (1)",
    transform: "translate(0 -55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-47",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7645",
    "data-name": "Ret\\xE2ngulo 7645",
    width: 33.12,
    height: 0.25,
    transform: "translate(416.78 398.49)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7646",
    "data-name": "Ret\\xE2ngulo 7646",
    width: 8.69,
    height: 0.25,
    transform: "translate(322.53 401.21)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7647",
    "data-name": "Ret\\xE2ngulo 7647",
    width: 19.19,
    height: 0.25,
    transform: "translate(396.59 389.21)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7648",
    "data-name": "Ret\\xE2ngulo 7648",
    width: 43.19,
    height: 0.25,
    transform: "translate(52.46 390.89)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7649",
    "data-name": "Ret\\xE2ngulo 7649",
    width: 6.33,
    height: 0.25,
    transform: "translate(104.56 390.89)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7650",
    "data-name": "Ret\\xE2ngulo 7650",
    width: 93.68,
    height: 0.25,
    transform: "translate(131.47 395.11)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6579",
    "data-name": "Caminho 6579",
    d: "M237,337.8H43.92a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,43.92,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.92,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6580",
    "data-name": "Caminho 6580",
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7651",
    "data-name": "Ret\\xE2ngulo 7651",
    width: 500,
    height: 0.25,
    transform: "translate(0 382.4)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6581",
    "data-name": "Caminho 6581",
    d: "M203.12,319.61H82.52V101.3l1.23-1.18a84.87,84.87,0,0,1,59.07-23.73h0a84.85,84.85,0,0,1,59.07,23.73l1.23,1.18Zm-112.6-8h104.6V104.74a77.38,77.38,0,0,0-104.6,0Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6582",
    "data-name": "Caminho 6582",
    d: "M196.64,140.17v-6H145.82V83.35h-6v50.82H89v6h50.82v54.81H89v6h50.82V255.8H89v6h50.82v50.81h6V261.8h50.82v-6H145.82V200.98h50.82v-6H145.82V140.17Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6583",
    "data-name": "Caminho 6583",
    d: "M207.12,323.61H78.52V99.67l1.17-1.17A89.38,89.38,0,0,1,206,98.5l1.17,1.17Zm-120.6-8h112.6V103a81.37,81.37,0,0,0-112.6,0Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6584",
    "data-name": "Caminho 6584",
    d: "M415.68,319.61H295.08V101.3l1.23-1.18a84.87,84.87,0,0,1,59.07-23.73h0a84.87,84.87,0,0,1,59.08,23.73l1.22,1.18Zm-112.6-8h104.6V104.74a77.38,77.38,0,0,0-104.6,0Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6585",
    "data-name": "Caminho 6585",
    d: "M409.2,140.17v-6H358.38V83.35h-6v50.82H301.57v6h50.81v54.81H301.57v6h50.81V255.8H301.57v6h50.81v50.81h6V261.8H409.2v-6H358.38V200.98H409.2v-6H358.38V140.17Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6586",
    "data-name": "Caminho 6586",
    d: "M419.68,323.61H291.08V99.67l1.18-1.17a89.37,89.37,0,0,1,126.25,0l1.17,1.17Zm-120.6-8h112.6V103a81.37,81.37,0,0,0-112.6,0Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7652",
    "data-name": "Ret\\xE2ngulo 7652",
    width: 22.72,
    height: 6.1,
    rx: 1.32,
    transform: "translate(272.58 370.78) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7653",
    "data-name": "Ret\\xE2ngulo 7653",
    width: 22.72,
    height: 6.1,
    rx: 1.32,
    transform: "translate(248.75 370.78) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7654",
    "data-name": "Ret\\xE2ngulo 7654",
    width: 22.72,
    height: 6.1,
    rx: 1.32,
    transform: "translate(259.37 363.22) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7655",
    "data-name": "Ret\\xE2ngulo 7655",
    width: 22.72,
    height: 6.1,
    rx: 1.32,
    transform: "translate(235.59 363.22) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7656",
    "data-name": "Ret\\xE2ngulo 7656",
    width: 22.72,
    height: 6.1,
    rx: 1.32,
    transform: "translate(103.92 367) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7657",
    "data-name": "Ret\\xE2ngulo 7657",
    width: 22.72,
    height: 6.1,
    rx: 1.32,
    transform: "translate(80.09 367) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7658",
    "data-name": "Ret\\xE2ngulo 7658",
    width: 22.72,
    height: 6.1,
    rx: 1.32,
    transform: "translate(90.7 359.45) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7659",
    "data-name": "Ret\\xE2ngulo 7659",
    width: 22.72,
    height: 6.1,
    rx: 1.32,
    transform: "translate(66.92 359.45) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7660",
    "data-name": "Ret\\xE2ngulo 7660",
    width: 22.72,
    height: 6.1,
    rx: 1.32,
    transform: "translate(89.55 78.98) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7661",
    "data-name": "Ret\\xE2ngulo 7661",
    width: 22.72,
    height: 6.1,
    rx: 1.32,
    transform: "translate(100.16 71.43) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7662",
    "data-name": "Ret\\xE2ngulo 7662",
    width: 22.72,
    height: 6.1,
    rx: 1.32,
    transform: "translate(76.38 71.43) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7663",
    "data-name": "Ret\\xE2ngulo 7663",
    width: 22.72,
    height: 6.1,
    rx: 1.32,
    transform: "translate(449.55 85.82) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7664",
    "data-name": "Ret\\xE2ngulo 7664",
    width: 22.72,
    height: 6.1,
    rx: 1.32,
    transform: "translate(436.32 78.26) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7665",
    "data-name": "Ret\\xE2ngulo 7665",
    width: 59.83,
    height: 59.83,
    transform: "translate(297.03 323.43)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7666",
    "data-name": "Ret\\xE2ngulo 7666",
    width: 36.75,
    height: 59.83,
    transform: "translate(356.87 323.43)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6587",
    "data-name": "Caminho 6587",
    d: "M371.57,323.43v22.65l.95-.86,1.68,1.05,1.47-1.05,1.89,1.05,1.99-1.05,1.26,1.05,1.46-.77V323.43Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6588",
    "data-name": "Caminho 6588",
    d: "M371.57,323.43v22.65l.95-.86,1.68,1.05,1.47-1.05,1.89,1.05,1.99-1.05,1.26,1.05,1.46-.77V323.43Z",
    fill: "#e0e0e0",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7667",
    "data-name": "Ret\\xE2ngulo 7667",
    width: 35.63,
    height: 35.63,
    transform: "translate(377.12 347.64)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7668",
    "data-name": "Ret\\xE2ngulo 7668",
    width: 21.88,
    height: 35.63,
    transform: "translate(412.74 347.64)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6589",
    "data-name": "Caminho 6589",
    d: "M405.94,357.65H370.31l6.81-10.01h35.62Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6590",
    "data-name": "Caminho 6590",
    d: "M419.19,357.65h21.88l-6.44-10.01H412.74Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7669",
    "data-name": "Ret\\xE2ngulo 7669",
    width: 35.63,
    height: 35.63,
    transform: "translate(260.58 347.64)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7670",
    "data-name": "Ret\\xE2ngulo 7670",
    width: 21.88,
    height: 35.63,
    transform: "translate(296.2 347.64)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6591",
    "data-name": "Caminho 6591",
    d: "M289.4,338.7H253.77l6.81,8.94H296.2Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6592",
    "data-name": "Caminho 6592",
    d: "M302.65,338.7h21.88l-6.44,8.94H296.2Z",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-47"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-47",
    cx: 193.89,
    cy: 11.32,
    rx: 193.89,
    ry: 11.32,
    transform: "translate(51.29 401.07)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Process--inject-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7671",
    "data-name": "Ret\\xE2ngulo 7671",
    width: 192.653,
    height: 10.04,
    rx: 3.05,
    transform: "translate(182.74 229.29)",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7672",
    "data-name": "Ret\\xE2ngulo 7672",
    width: 192.653,
    height: 10.04,
    rx: 3.05,
    transform: "translate(182.74 229.29)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6593",
    "data-name": "Caminho 6593",
    d: "M369.255,244.81H188.864c-6.406-.006-11.6-3.821-11.6-8.53v-3.94c.008-4.709,5.2-8.524,11.6-8.53h180.39c6.408.005,11.6,3.82,11.618,8.53v3.94C380.858,240.99,375.663,244.8,369.255,244.81Zm-180.39-19.17c-5.033.005-9.113,3-9.128,6.7v3.94c.008,3.7,4.092,6.7,9.128,6.7h180.39c5.036,0,9.121-3,9.128-6.7v-3.94c-.015-3.7-4.1-6.695-9.128-6.7Z",
    transform: "translate(0)",
    fill: "#e5e6fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6595",
    "data-name": "Caminho 6595",
    d: "M339.24,229.29H187.255c-2.474.033-4.457,1.387-4.465,3.05v3.94c.008,1.663,1.99,3.017,4.465,3.05H324.3Z",
    fill: "#7f82f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear-3--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6600",
    "data-name": "Caminho 6600",
    d: "M424.67,137.4l-8.75.14a45,45,0,0,0-3.92-6.77l4.5-7.51a52,52,0,0,0-7.78-7.78l-7.51,4.5a44.266,44.266,0,0,0-6.78-3.92l.15-8.76A52.36,52.36,0,0,0,384,104.45l-4.26,7.67c-1.29-.11-2.59-.18-3.91-.18s-2.62.07-3.91.18l-4.26-7.67A52.54,52.54,0,0,0,357,107.3l.15,8.76a44.171,44.171,0,0,0-6.77,3.92l-7.51-4.5a52.571,52.571,0,0,0-7.79,7.78l4.51,7.51a43.358,43.358,0,0,0-3.92,6.77l-8.76-.14A52.361,52.361,0,0,0,324,148l7.67,4.25c-.12,1.29-.19,2.6-.19,3.91s.07,2.63.19,3.91L324,164.36A52.36,52.36,0,0,0,326.89,175l8.76-.14a43.362,43.362,0,0,0,3.92,6.77l-4.51,7.51a52.572,52.572,0,0,0,7.79,7.78l7.51-4.5a44.173,44.173,0,0,0,6.77,3.92l-.15,8.75a51.91,51.91,0,0,0,10.63,2.86l4.26-7.67c1.29.11,2.59.18,3.91.18s2.62-.07,3.91-.18l4.26,7.67a51.738,51.738,0,0,0,10.63-2.86l-.15-8.75a44.266,44.266,0,0,0,6.78-3.92l7.51,4.5a52,52,0,0,0,7.78-7.78l-4.5-7.51a45,45,0,0,0,3.92-6.77l8.75.14a51.092,51.092,0,0,0,2.85-10.63l-7.66-4.26c.11-1.28.18-2.59.18-3.91s-.07-2.62-.18-3.91l7.66-4.25a51.09,51.09,0,0,0-2.85-10.64Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6601",
    "data-name": "Caminho 6601",
    d: "M424.67,137.4l-8.75.14a45,45,0,0,0-3.92-6.77l4.5-7.51a52,52,0,0,0-7.78-7.78l-7.51,4.5a44.266,44.266,0,0,0-6.78-3.92l.15-8.76A52.36,52.36,0,0,0,384,104.45l-4.26,7.67c-1.29-.11-2.59-.18-3.91-.18s-2.62.07-3.91.18l-4.26-7.67A52.54,52.54,0,0,0,357,107.3l.15,8.76a44.171,44.171,0,0,0-6.77,3.92l-7.51-4.5a52.571,52.571,0,0,0-7.79,7.78l4.51,7.51a43.358,43.358,0,0,0-3.92,6.77l-8.76-.14A52.361,52.361,0,0,0,324,148l7.67,4.25c-.12,1.29-.19,2.6-.19,3.91s.07,2.63.19,3.91L324,164.36A52.36,52.36,0,0,0,326.89,175l8.76-.14a43.362,43.362,0,0,0,3.92,6.77l-4.51,7.51a52.572,52.572,0,0,0,7.79,7.78l7.51-4.5a44.173,44.173,0,0,0,6.77,3.92l-.15,8.75a51.91,51.91,0,0,0,10.63,2.86l4.26-7.67c1.29.11,2.59.18,3.91.18s2.62-.07,3.91-.18l4.26,7.67a51.738,51.738,0,0,0,10.63-2.86l-.15-8.75a44.266,44.266,0,0,0,6.78-3.92l7.51,4.5a52,52,0,0,0,7.78-7.78l-4.5-7.51a45,45,0,0,0,3.92-6.77l8.75.14a51.092,51.092,0,0,0,2.85-10.63l-7.66-4.26c.11-1.28.18-2.59.18-3.91s-.07-2.62-.18-3.91l7.66-4.25a51.09,51.09,0,0,0-2.85-10.64Z",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_736",
    "data-name": "Elipse 736",
    cx: 26.26,
    cy: 26.26,
    r: 26.26,
    transform: "translate(349.52 129.93)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6602",
    "data-name": "Caminho 6602",
    d: "M389.75,161.65a3.67,3.67,0,0,0,0-4.89l-.07-.08v-.05l-8.23-8.23c-3.3-3.3-8.43,1.82-5.12,5.13l2,2h-14c-4.66,0-4.67,7.25,0,7.25h14l-2,2c-3.31,3.31,1.82,8.43,5.12,5.13l8.23-8.23v-.06Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6603",
    "data-name": "Caminho 6603",
    d: "M389.75,161.65a3.67,3.67,0,0,0,0-4.89l-.07-.08v-.05l-8.23-8.23c-3.3-3.3-8.43,1.82-5.12,5.13l2,2h-14c-4.66,0-4.67,7.25,0,7.25h14l-2,2c-3.31,3.31,1.82,8.43,5.12,5.13l8.23-8.23v-.06Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6604",
    "data-name": "Caminho 6604",
    d: "M389.75,158.65a3.67,3.67,0,0,0,0-4.89l-.07-.08v-.05l-8.23-8.23c-3.3-3.3-8.43,1.82-5.12,5.13l2,2h-14c-4.66,0-4.67,7.25,0,7.25h14l-2,2c-3.31,3.31,1.82,8.43,5.12,5.13l8.23-8.23v-.06Z",
    fill: "#7f82f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear-2--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6607",
    "data-name": "Caminho 6607",
    d: "M315.23,166.61a40.459,40.459,0,0,0,1.14-6.36l9.85-2.53v-3.73l-9.9-2.4a41.35,41.35,0,0,0-3.41-12.4l7.26-7.12c-.59-1.1-1.22-2.17-1.89-3.22l-9.76,2.86a41.531,41.531,0,0,0-9.15-9l2.73-9.81c-1-.65-2.14-1.25-3.24-1.83l-7,7.36a41,41,0,0,0-6.1-2.11,40.538,40.538,0,0,0-6.35-1.14l-2.54-9.85h-3.72l-2.41,9.9a41.24,41.24,0,0,0-12.4,3.42l-7.12-7.27c-1.1.59-2.17,1.22-3.22,1.89l2.86,9.76a41.53,41.53,0,0,0-9,9.15L232,129.42c-.65,1.05-1.25,2.14-1.83,3.24l7.36,7a40.892,40.892,0,0,0-2.11,6.09,41.741,41.741,0,0,0-1.14,6.35l-9.85,2.54v3.73l9.9,2.4a41.241,41.241,0,0,0,3.42,12.4l-7.26,7.12c.59,1.1,1.21,2.17,1.88,3.22l9.76-2.86a41.53,41.53,0,0,0,9.15,9l-2.73,9.81c1.05.65,2.14,1.25,3.25,1.83l7-7.36a40.888,40.888,0,0,0,6.09,2.11,40.458,40.458,0,0,0,6.36,1.14l2.53,9.85h3.73l2.4-9.9a41.08,41.08,0,0,0,12.4-3.42l7.12,7.27c1.1-.59,2.17-1.22,3.22-1.89l-2.86-9.76a41.311,41.311,0,0,0,9-9.15l9.81,2.73c.65-1.05,1.25-2.14,1.83-3.25l-7.36-7a40.886,40.886,0,0,0,2.16-6.05Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6608",
    "data-name": "Caminho 6608",
    d: "M315.23,166.61a40.459,40.459,0,0,0,1.14-6.36l9.85-2.53v-3.73l-9.9-2.4a41.35,41.35,0,0,0-3.41-12.4l7.26-7.12c-.59-1.1-1.22-2.17-1.89-3.22l-9.76,2.86a41.531,41.531,0,0,0-9.15-9l2.73-9.81c-1-.65-2.14-1.25-3.24-1.83l-7,7.36a41,41,0,0,0-6.1-2.11,40.538,40.538,0,0,0-6.35-1.14l-2.54-9.85h-3.72l-2.41,9.9a41.24,41.24,0,0,0-12.4,3.42l-7.12-7.27c-1.1.59-2.17,1.22-3.22,1.89l2.86,9.76a41.53,41.53,0,0,0-9,9.15L232,129.42c-.65,1.05-1.25,2.14-1.83,3.24l7.36,7a40.892,40.892,0,0,0-2.11,6.09,41.741,41.741,0,0,0-1.14,6.35l-9.85,2.54v3.73l9.9,2.4a41.241,41.241,0,0,0,3.42,12.4l-7.26,7.12c.59,1.1,1.21,2.17,1.88,3.22l9.76-2.86a41.53,41.53,0,0,0,9.15,9l-2.73,9.81c1.05.65,2.14,1.25,3.25,1.83l7-7.36a40.888,40.888,0,0,0,6.09,2.11,40.458,40.458,0,0,0,6.36,1.14l2.53,9.85h3.73l2.4-9.9a41.08,41.08,0,0,0,12.4-3.42l7.12,7.27c1.1-.59,2.17-1.22,3.22-1.89l-2.86-9.76a41.311,41.311,0,0,0,9-9.15l9.81,2.73c.65-1.05,1.25-2.14,1.83-3.25l-7.36-7a40.886,40.886,0,0,0,2.16-6.05Z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_737",
    "data-name": "Elipse 737",
    cx: 26.15,
    cy: 26.15,
    r: 26.15,
    transform: "translate(249.17 130.04)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6609",
    "data-name": "Caminho 6609",
    d: "M287.89,161.25a3.3,3.3,0,0,0,0-4.4l-.06-.07h0l-7.41-7.41c-3-3-7.58,1.64-4.61,4.61.61.62,1.23,1.23,1.84,1.84h-12.6c-4.2,0-4.21,6.53,0,6.53h12.58c-.61.61-1.23,1.22-1.84,1.84-3,3,1.64,7.58,4.61,4.61l7.41-7.41Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6610",
    "data-name": "Caminho 6610",
    d: "M287.89,161.25a3.3,3.3,0,0,0,0-4.4l-.06-.07h0l-7.41-7.41c-3-3-7.58,1.64-4.61,4.61.61.62,1.23,1.23,1.84,1.84h-12.6c-4.2,0-4.21,6.53,0,6.53h12.58c-.61.61-1.23,1.22-1.84,1.84-3,3,1.64,7.58,4.61,4.61l7.41-7.41Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6611",
    "data-name": "Caminho 6611",
    d: "M287.89,158.55a3.3,3.3,0,0,0,0-4.4l-.06-.07h0l-7.41-7.41c-3-3-7.58,1.64-4.61,4.61.61.62,1.23,1.23,1.84,1.84h-12.6c-4.2,0-4.21,6.53,0,6.53h12.58c-.61.61-1.23,1.22-1.84,1.84-3,3,1.64,7.58,4.61,4.61l7.41-7.41a.1.1,0,0,0,0-.05Z",
    fill: "#7f82f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear-1--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6614",
    "data-name": "Caminho 6614",
    d: "M221.92,139.91l-7.59.13a39.27,39.27,0,0,0-3.39-5.87l3.9-6.5a46.25,46.25,0,0,0-6.74-6.75l-6.51,3.91a37.541,37.541,0,0,0-5.87-3.4l.13-7.58a45,45,0,0,0-9.21-2.47L183,118c-1.12-.1-2.25-.16-3.39-.16s-2.27.06-3.39.16l-3.69-6.64a44.879,44.879,0,0,0-9.2,2.47l.12,7.58a37.9,37.9,0,0,0-5.86,3.4L151,120.92a45.279,45.279,0,0,0-6.74,6.75l3.9,6.5a38.47,38.47,0,0,0-3.4,5.87l-7.58-.13a45.14,45.14,0,0,0-2.47,9.21l6.64,3.69c-.1,1.11-.16,2.24-.16,3.38s.06,2.27.16,3.39l-6.64,3.69a45.14,45.14,0,0,0,2.47,9.21l7.58-.13a38.47,38.47,0,0,0,3.4,5.87l-3.9,6.5a44.74,44.74,0,0,0,6.74,6.74l6.51-3.9a37.9,37.9,0,0,0,5.86,3.4l-.12,7.58a44.879,44.879,0,0,0,9.2,2.47l3.69-6.64c1.12.1,2.25.16,3.39.16s2.27-.06,3.39-.16l3.68,6.64a45,45,0,0,0,9.21-2.47l-.13-7.58a37.537,37.537,0,0,0,5.87-3.4l6.51,3.9a45.691,45.691,0,0,0,6.74-6.74l-3.9-6.5a39.269,39.269,0,0,0,3.39-5.87l7.59.13a45.8,45.8,0,0,0,2.47-9.21l-6.64-3.69c.09-1.12.15-2.24.15-3.39s-.06-2.27-.15-3.38l6.64-3.69a45.8,45.8,0,0,0-2.43-9.21Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6615",
    "data-name": "Caminho 6615",
    d: "M221.92,139.91l-7.59.13a39.27,39.27,0,0,0-3.39-5.87l3.9-6.5a46.25,46.25,0,0,0-6.74-6.75l-6.51,3.91a37.541,37.541,0,0,0-5.87-3.4l.13-7.58a45,45,0,0,0-9.21-2.47L183,118c-1.12-.1-2.25-.16-3.39-.16s-2.27.06-3.39.16l-3.69-6.64a44.879,44.879,0,0,0-9.2,2.47l.12,7.58a37.9,37.9,0,0,0-5.86,3.4L151,120.92a45.279,45.279,0,0,0-6.74,6.75l3.9,6.5a38.47,38.47,0,0,0-3.4,5.87l-7.58-.13a45.14,45.14,0,0,0-2.47,9.21l6.64,3.69c-.1,1.11-.16,2.24-.16,3.38s.06,2.27.16,3.39l-6.64,3.69a45.14,45.14,0,0,0,2.47,9.21l7.58-.13a38.47,38.47,0,0,0,3.4,5.87l-3.9,6.5a44.74,44.74,0,0,0,6.74,6.74l6.51-3.9a37.9,37.9,0,0,0,5.86,3.4l-.12,7.58a44.879,44.879,0,0,0,9.2,2.47l3.69-6.64c1.12.1,2.25.16,3.39.16s2.27-.06,3.39-.16l3.68,6.64a45,45,0,0,0,9.21-2.47l-.13-7.58a37.537,37.537,0,0,0,5.87-3.4l6.51,3.9a45.691,45.691,0,0,0,6.74-6.74l-3.9-6.5a39.269,39.269,0,0,0,3.39-5.87l7.59.13a45.8,45.8,0,0,0,2.47-9.21l-6.64-3.69c.09-1.12.15-2.24.15-3.39s-.06-2.27-.15-3.38l6.64-3.69a45.8,45.8,0,0,0-2.43-9.21Z",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_738",
    "data-name": "Elipse 738",
    cx: 31.2,
    cy: 31.2,
    r: 31.2,
    transform: "translate(148.37 124.99)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6616",
    "data-name": "Caminho 6616",
    d: "M190.12,160.86a2.93,2.93,0,0,0,0-3.91v-.07h0l-6.59-6.58c-2.64-2.64-6.74,1.46-4.1,4.1L181,156H169.82c-3.74,0-3.74,5.8,0,5.8H181l-1.64,1.64c-2.64,2.64,1.46,6.74,4.1,4.1l6.59-6.59h0Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6617",
    "data-name": "Caminho 6617",
    d: "M190.12,160.86a2.93,2.93,0,0,0,0-3.91v-.07h0l-6.59-6.58c-2.64-2.64-6.74,1.46-4.1,4.1L181,156H169.82c-3.74,0-3.74,5.8,0,5.8H181l-1.64,1.64c-2.64,2.64,1.46,6.74,4.1,4.1l6.59-6.59h0Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6618",
    "data-name": "Caminho 6618",
    d: "M190.12,158.46a2.93,2.93,0,0,0,0-3.91v-.07h0l-6.59-6.58c-2.64-2.64-6.74,1.46-4.1,4.1l1.64,1.63H169.82c-3.74,0-3.74,5.8,0,5.8H181L179.36,161c-2.64,2.64,1.46,6.74,4.1,4.1l6.59-6.59h0Z",
    fill: "#7f82f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6621",
    "data-name": "Caminho 6621",
    d: "M150.62,204s9.7,20.24,13.94,26.08c3.67,5.07,17.15,17.54,17.15,17.54l3.72-.4a2.85,2.85,0,0,1,2.85,1.53l.42.81a2.85,2.85,0,0,0,.68.86l.66.57a2.85,2.85,0,0,1,.72,3.41l-.51,1a2.84,2.84,0,0,1-2,1.56l-4,.82a2.86,2.86,0,0,1-2.77-1l-3.4-4.11s-17.94-13.15-22.54-18.88c-3.71-4.62-11-21-11-21Z",
    fill: "#1ed6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6622",
    "data-name": "Caminho 6622",
    d: "M202.92,303.94a28.57,28.57,0,1,0-57.14,0Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6623",
    "data-name": "Caminho 6623",
    d: "M202.92,303.94a28.57,28.57,0,1,0-57.14,0Z",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10512",
    "data-name": "Grupo 10512",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6624",
    "data-name": "Caminho 6624",
    d: "M195.9,294.71a2.26,2.26,0,0,1-2.88-1,21.29,21.29,0,0,0-37.34,0,2.27,2.27,0,0,1-2.88,1h0a2.24,2.24,0,0,1-1.11-3.11,25.79,25.79,0,0,1,45.32,0,2.25,2.25,0,0,1-1.11,3.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6625",
    "data-name": "Caminho 6625",
    d: "M198.05,219.37,179,283.15a21.533,21.533,0,0,1,2.87.85q7.94-26.55,15.86-53.1l3.21-10.73C201.5,218.31,198.6,217.52,198.05,219.37Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10513",
    "data-name": "Grupo 10513",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6626",
    "data-name": "Caminho 6626",
    d: "M198.05,219.37,179,283.15a21.533,21.533,0,0,1,2.87.85q7.94-26.55,15.86-53.1l3.21-10.73C201.5,218.31,198.6,217.52,198.05,219.37Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6627",
    "data-name": "Caminho 6627",
    d: "M187.8,266.79q6.93-23.22,13.87-46.42c.83-2.78-3.52-4-4.34-1.2q-6.95,23.21-13.87,46.42c-.83,2.78,3.51,4,4.34,1.2Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6628",
    "data-name": "Caminho 6628",
    d: "M143.26,303.94h62.27a7.87,7.87,0,0,1,7.87,7.87v96.51h-78V311.81a7.87,7.87,0,0,1,7.86-7.87Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6629",
    "data-name": "Caminho 6629",
    d: "M143.26,303.94h62.27a7.87,7.87,0,0,1,7.87,7.87v96.51h-78V311.81a7.87,7.87,0,0,1,7.86-7.87Z",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6630",
    "data-name": "Caminho 6630",
    d: "M176.39,386.17l5,19,8.43-2.34-3.6-20.33Z",
    fill: "#1ed6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6631",
    "data-name": "Caminho 6631",
    d: "M191.47,400.79a.25.25,0,0,1-.22-.13.22.22,0,0,1,.05-.25c.11-.12,2.74-2.74,4.34-2.74a1.16,1.16,0,0,1,.8.31.83.83,0,0,1,.27.92c-.24.58-1.33,1.09-2.44,1.39a16.6,16.6,0,0,1-2.8.5Zm.61-.47c1.72-.25,4-.88,4.22-1.57a.448.448,0,0,0-.17-.45.61.61,0,0,0-.49-.19,1.42,1.42,0,0,0-.42.06A10.09,10.09,0,0,0,192.08,400.32Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6632",
    "data-name": "Caminho 6632",
    d: "M191.36,400.8a.19.19,0,0,1-.15-.16c0-.12-.44-2.59.45-3.83a1.65,1.65,0,0,1,1.07-.69.856.856,0,0,1,1,.39c.47.95-1.15,3.47-2.09,4.23a.12.12,0,0,1-.09,0,.17.17,0,0,1-.19.06Zm1.34-4.24a1.16,1.16,0,0,0-.66.47,5.2,5.2,0,0,0-.44,3.06c.93-1,1.93-2.85,1.71-3.44,0,0-.1-.2-.49-.13h-.12Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6633",
    "data-name": "Caminho 6633",
    d: "M190.22,399.78l-9.74,2.66a.81.81,0,0,0-.6.82l.4,8.41a1.34,1.34,0,0,0,1.4,1.29.86.86,0,0,0,.28,0c3.5-1,6.57-2.06,10.95-3.25,5.16-1.4,4-.43,10.11-2,3.66-.95,3.2-5.29,1.6-5.07-7.34,1-8.66-.9-12.09-2.69A3.23,3.23,0,0,0,190.22,399.78Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6634",
    "data-name": "Caminho 6634",
    d: "M82.97,381.53l-8.04,17.93,8.03,3.48,9.96-18.09Z",
    fill: "#1ed6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6635",
    "data-name": "Caminho 6635",
    d: "M85.53,402.38a.22.22,0,0,1-.09-.24.2.2,0,0,1,.19-.16c.16,0,3.86-.41,5.1.6a1.15,1.15,0,0,1,.43.74.83.83,0,0,1-.37.88c-.55.3-1.72,0-2.77-.44a16.79,16.79,0,0,1-2.49-1.38Zm.77,0c1.49.89,3.63,1.81,4.27,1.43.08,0,.19-.14.15-.45a.61.61,0,0,0-.27-.45,1.251,1.251,0,0,0-.37-.22,10.249,10.249,0,0,0-3.78-.3Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6636",
    "data-name": "Caminho 6636",
    d: "M85.43,402.32a.2.2,0,0,1,0-.22c0-.1,1.28-2.29,2.75-2.7a1.65,1.65,0,0,1,1.27.14c.53.3.58.66.5.9-.24,1-3.08,2-4.29,2a.16.16,0,0,1-.09,0,.21.21,0,0,1-.14-.12Zm3.71-2.45a1.08,1.08,0,0,0-.81-.05,5.1,5.1,0,0,0-2.26,2.1c1.32-.16,3.29-1,3.49-1.61,0-.06,0-.21-.3-.4h-.12Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6637",
    "data-name": "Caminho 6637",
    d: "M85.18,400.81l-9.25-4.05a.83.83,0,0,0-1,.26l-5,6.8a1.36,1.36,0,0,0,.28,1.89,2,2,0,0,0,.25.14c3.36,1.41,6.4,2.52,10.55,4.35,4.9,2.15,3.4,2.19,9.12,4.79,3.45,1.57,5.82-2.1,4.43-2.94-6.36-3.79-6.17-6.13-7.71-9.68a3.24,3.24,0,0,0-1.67-1.56Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6638",
    "data-name": "Caminho 6638",
    d: "M154.79,164.77s6.85-2.1,5.13-5.23c-1.5-2.71-4,.56-4,.56Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6639",
    "data-name": "Caminho 6639",
    d: "M154.79,164.77s6.85-2.1,5.13-5.23c-1.5-2.71-4,.56-4,.56Z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6640",
    "data-name": "Caminho 6640",
    d: "M149.87,187.72l-1.33,6.34-9.43-3.22,2.82-7.28Z",
    fill: "#1ed6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6641",
    "data-name": "Caminho 6641",
    d: "M149.21,190.88a5.53,5.53,0,0,1-2.75-3.67l1.55-.47,1.86,1Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6644",
    "data-name": "Caminho 6644",
    d: "M137.72,171.08c.36,7.57.34,10.78,4.18,14.77,5.9,4.11,15.2,4,17.15-3.46,1.76-6.74.88-18-6.64-21.22a10.53,10.53,0,0,0-13.86,5.24,10.12,10.12,0,0,0-.83,4.67Z",
    fill: "#1ed6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6646",
    "data-name": "Caminho 6646",
    d: "M134.19,193.16l1.91-2.23a4.39,4.39,0,0,1,4.81-1.25l6.52,2.35a4.38,4.38,0,0,1,2.69,2.8l.74,2.33Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6647",
    "data-name": "Caminho 6647",
    d: "M134.19,193.16l1.91-2.23a4.39,4.39,0,0,1,4.81-1.25l6.52,2.35a4.38,4.38,0,0,1,2.69,2.8l.74,2.33Z",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6648",
    "data-name": "Caminho 6648",
    d: "M148.12,250.44s22.34,55.87,27.93,75.23c4.56,15.75,13.77,64.33,13.77,64.33l-14,3.57s-12.17-47.71-17.46-63.24c-4.48-13.14-16-39.22-25.57-49.3-1.61-1.7-6.14-3.61-7.7-5.36-3.21-3.62-6.92-12.93-7.93-17.67-.46-2.16,0-8.83,0-8.83Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6649",
    "data-name": "Caminho 6649",
    d: "M148.12,250.44s-5.34,16.95-7.65,22.39c-1.24,2.95-4.36,8.57-5.58,11.52-5.74,13.85-14.84,42.7-20.07,56.49-5.16,13.57-24.35,52.73-24.35,52.73L77.8,388s16.25-39.26,20.67-52.7c4.31-13.08,10.74-40,12.47-53.64.53-4.22.29-12.76.7-17,.37-3.9,2.33-15.5,2.33-15.5Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6650",
    "data-name": "Caminho 6650",
    d: "M113.63,250.53l36.63,5.11L158.68,205a7.26,7.26,0,0,0-5.35-8.23l-16.23-4.21a10.78,10.78,0,0,0-13.27,8.26Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6651",
    "data-name": "Caminho 6651",
    d: "M155.37,224.91l1.62-9.75-6.68-5.66Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6652",
    "data-name": "Caminho 6652",
    d: "M77.81,384.54l-1.88,4.38,14.63,6.75,2.12-4.13Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6653",
    "data-name": "Caminho 6653",
    d: "M174.06,391.11l1.33,4.57,15.58-4.07-.97-4.54Z",
    fill: "#7f82f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6654",
    "data-name": "Caminho 6654",
    d: "M153.89,176s2-2.56.54-6.69,7-12.76,1.63-15.3c-3.34-1.58-4.31,2.87-4.31,2.87s-2.05-3.19-5-1.86c-1.7.77-1.25,3-1.25,3s-12.06,1.91-9.55,13.09a15.9,15.9,0,0,0,4.48,13s4.35-1.59,7.93.64C148.38,184.76,148.82,180.15,153.89,176Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6655",
    "data-name": "Caminho 6655",
    d: "M137.08,172.82s-3.79-3.06-4.09-6.2S136,168.79,137.08,172.82Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6656",
    "data-name": "Caminho 6656",
    d: "M153.28,173.14a5.85,5.85,0,0,1,1.94,4.06c.08,2.06-1.92,2.6-3.64,1.62s-3.48-3-2.73-4.88a2.7,2.7,0,0,1,4.43-.8Z",
    fill: "#1ed6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6657",
    "data-name": "Caminho 6657",
    d: "M119.18,264.55c1.46,11,8.81,21.7,12.92,27,1-2.66,1.93-5.08,2.79-7.17C122.39,274.22,119.18,264.55,119.18,264.55Z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6658",
    "data-name": "Caminho 6658",
    d: "M156.3,200.44s9.25,16.12,13.73,20.62c3.88,3.88,18.84,12.87,18.84,12.87l5.08-.09a2.61,2.61,0,0,1,2.13,1h0a2.64,2.64,0,0,0,1.22.89l.44.16a2.61,2.61,0,0,1,1.73,2.83l-.3,2.18a2.62,2.62,0,0,1-1.81,2.13l-4.09,1.29a2.6,2.6,0,0,1-2.47-.5l-5.07-4.3s-18.72-8-23.66-12.56c-3.71-3.39-10.95-16.84-10.95-16.84Z",
    fill: "#1ed6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6659",
    "data-name": "Caminho 6659",
    d: "M157.79,199.14l9.9,12.94L155,219.77l-7.75-13.48a5.44,5.44,0,0,1,1.41-7l1.47-1.12a5.44,5.44,0,0,1,7.66.97Z",
    fill: "#7f82f3"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWaiting);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/waiting.7d314eb0a941b6d018ed831aecd1524f.svg";